module.exports = __webpack_public_path__ + "img/banner-overlay-less-opacity.5760cd95.svg";